import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/Blog";
import { publishedPosts } from "@/data/blog-posts";
import { pageHead, SITE_URL } from "@/lib/seo";

const blogJsonLd = {
  "@context": "https://schema.org",
  "@type": "Blog",
  name: "Blog Clara Camille",
  description: "Dicas de nutrição, saúde e alimentação para brasileiros na Austrália.",
  url: `${SITE_URL}/blog`,
  author: { "@type": "Person", name: "Clara Camille", jobTitle: "Nutricionista", url: `${SITE_URL}/sobre` },
  blogPost: publishedPosts.map((post) => ({
    "@type": "BlogPosting",
    headline: post.title,
    url: `${SITE_URL}/blog/${post.slug}`,
    datePublished: post.date,
    dateModified: post.updated ?? post.date,
  })),
};

export const Route = createFileRoute("/blog/")({
  head: () =>
    pageHead({
      title: "Blog | Nutricionista brasileira na Austrália | Clara Camille",
      description:
        "Dicas de nutrição, receitas, guia de compras e saúde para brasileiros na Austrália. Blog da nutricionista Clara Camille.",
      path: "/blog",
      ogDescription: "Dicas de nutrição, receitas, guia de compras e saúde para brasileiros na Austrália.",
      jsonLd: [blogJsonLd],
    }),
  component: Page,
});
